







































































import Vue from "vue";

export default Vue.extend({
  name: "base-input",
  inheritAttrs: false,
  data: () => ({
    isFocused: false,
    hiddenPassword: true,
    reservedValue: null,
    reservedOtherInputValue: null,
  }),
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number],
    },
    validate: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    actionBg: {
      type: String,
    },
    enableAction: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Function,
    },
    inputClass: {
      type: String,
      default: "",
    },
    helpers: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
    },
    modern: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    cancelOnClickOutside: {
      type: Boolean,
      default: false,
    },
    initialOtherInput: {
      type: [String, Boolean, Number],
    },
  },
  methods: {
    onInput(e: Event) {
      const value = (e.target as HTMLInputElement).value;
      this.$emit("input", value);
    },
    toggleErrorMessage(e, activate) {
      if (!this.validate) return;
      console.log(e);

      console.log(this.$refs.op);

      (this.$refs.op as any).toggle(e);
    },
    onEnter(e: Event) {
      if (this.edit && this.enableAction && this.helpers) {
        this.edit((this.$refs.input as HTMLInputElement).value);
      }
    },
    onESC(e: Event) {
      if (!this.helpers) {
        return;
      }
      console.log(e);
      this.$emit("onESC", {
        input: this.reservedValue,
        other: this.reservedOtherInputValue,
      });
      this.$emit("cancel");
    },
    showHidePassword() {
      // (this.$refs.input as HTMLInputElement).focus();
      this.hiddenPassword = !this.hiddenPassword;
    },
    clickOutside(e: any) {
      if (!this.edit || !this.enableAction || !this.helpers) {
        return;
      }
      console.log(this.$refs.container);
      if (!this.$refs.container) return;
      if (!(this.$refs.container as HTMLDivElement).contains(e.target)) {
        const val = (this.$refs.input as HTMLInputElement).value;
        if (this.reservedValue !== val) {
          console.log(1);

          if (this.cancelOnClickOutside) {
            console.log(2);
            this.$emit("cancel", {});
            return;
          }
          console.log(3);
          this.edit(val);
        } else {
          console.log(4);

          this.$emit("cancel", { reason: "outside" });
          console.log("multiple close");

          // if (!val || !val.length) {
          this.$emit("closeMultiple");
          // }
        }
      }
    },
  },
  computed: {
    cssClasses() {
      return {
        "modern-input": this.modern,
      };
    },
    _actionBg() {
      return this.actionBg ? `bg-${this.actionBg}` : "";
    },
    _type() {
      if (this.type === "password" && !this.hiddenPassword) {
        return "text";
      }
      return this.type;
    },
  },
  mounted() {
    if (this.autofocus) {
      console.log("autofocus");

      (this.$refs.input as HTMLInputElement).focus();
    }
    this.reservedValue = this.value;
    this.reservedOtherInputValue = this.initialOtherInput;
    this.$nextTick(() => {
      window.addEventListener("click", this.clickOutside);
    });
  },
  destroyed() {
    window.removeEventListener("click", this.clickOutside);
  },
  watch: {
    // autofocus: {
    //   handler: function(n, l) {
    //     if (this.autofocus) {
    //       // (this.$refs.input as HTMLInputElement).focus();
    //     }
    //   },
    //   immediate: true
    // }
  },
});
